var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M45.39 23.93v-5.71c-.41 0-.8-.13-1.19-.14-1.35-.08-2.7-.08-4.05-.08a7.89 7.89 0 00-3.18.6 7.14 7.14 0 00-4.38 4.78 11.29 11.29 0 00-.4 3v4.46a4 4 0 010 .49h-5.58v6.42h4.18a4.86 4.86 0 011.32 0v16.17c1 .08 6.14 0 6.63 0V37.71h3.68a13.82 13.82 0 001.82 0c.11-.81.87-5.91.74-6.42h-6.2a.9.9 0 01-.08-.21v-4.76a2.13 2.13 0 011-1.86 2.62 2.62 0 011.53-.46l3.51-.07z","key":0}),React.createElement("path",{"d":"M36 72a36 36 0 1125.46-10.54A36 36 0 0136 72zm0-69a33 33 0 1023.33 9.67A33 33 0 0036 3z","key":1})]));
}

Facebook.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 73 73"};

module.exports = Facebook;

Facebook.default = Facebook;
